(function (factory) {
    typeof define === 'function' && define.amd ? define('loadResults', factory) :
    factory();
})

((function () { 'use strict';
    jQuery(document).ready(function () {
        jQuery(".search-results-pagination").on('click', 'a', function (e) {
            e.preventDefault();
            var nonce = jQuery(this).attr("data-nonce");
            var page = jQuery(this).attr("data-page");
            var searchQuery = jQuery(this).attr("data-search-query");
            jQuery.ajax({
                type: "post",
                dataType: "json",
                url: stcaAjax.ajaxurl,
                data: {
                    action: "load_more",
                    nonce: nonce,
                    page: page,
                    searchQuery: searchQuery
                },
                success: function (response) {
                    if (response.success === true) {                    
                        jQuery(".search-results-block__list").empty();
                        jQuery(".search-results-block__list").append(response.data.articles);
                    }
                }
            });
        });
    });
}));